<template>
  <v-container fluid>
    <v-sheet rounded>
      <v-container fluid>
        <span class="text-h6">{{title}}</span>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-row class="mt-5">
            <v-col>
              <phone-number-format
                v-model="form.phoneNo"
                clearable
                bindClass="body-2"
                :label="$_strings.userAdmin.PHONE_INPUT_LABEL"
                :required="true"
              ></phone-number-format>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :disabled="isEditing"
                v-model="form.email"
                :label="$_strings.userAdmin.EMAIL_INPUT_LABEL"
                :rules="rules.email"
                placeholder="email@mail.com"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :disabled="form.roleRolesName === 'SUPER ADMIN' && form.email.toLowerCase() === 'developer@mail.com'"
                :label="$_strings.userAdmin.ROLE_INPUT_LABEL"
                :items="roles"
                v-model="form.rolesId"
                item-value="rolesId"
                item-text="rolesName"
                :rules="rules.rolesId"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="12" v-if="!form.imageUrl">
              <v-file-input
                :label="$_strings.userAdmin.IMAGE_INPUT_LABEL"
                :clearable="false"
                :rules="!form.imageUrl ? rules.imageUrl : []"
                ref="imageInput"
                type="file"
                accept="image/*"
                @change="setFileInput"
              />
            </v-col>
            <v-col :cols="12" sm="4" v-else>
              <v-card
                class="mx-auto"
                outlined
              >
                <v-img
                  :src="form.imageUrl"
                  contain
                  aspect-ratio="1"
                  height="200"
                  lazy-src="../../assets/images/placeholder-image.png"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                    </v-row>
                  </template>
                </v-img>
                <v-card-actions class="white">
                  <v-btn
                    color="red"
                    small
                    block
                    class="pa-4 white--text"
                    @click="deleteFile"
                    :loading="formUpload.isLoading"
                  >
                    Hapus Gambar
                    <v-icon
                      right
                      dark
                    >
                      mdi-trash-can
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-btn @click="$router.go(-1)">
                {{$_strings.common.BACK}}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="success" @click="submit">
                {{$_strings.common.SAVE}}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-sheet>
  </v-container>
</template>

<script>

export default {
  name: 'UserAdminCreate',
  beforeDestroy() {
    if (this.fileQueueDeletion.length && this.isSubmited) {
      Promise.all(this.fileQueueDeletion.map((payload) => this.$_services.uploads.deleteFile(payload)));
    }
  },
  data() {
    return {
      valid: false,
      uploadingImage: false,
      formUpload: {
        fileName: '',
        isLoading: false,
        file: null,
        base64: null,
        fileType: '',
      },
      form: {
        email: '',
        rolesId: null,
        imageUrl: '',
        phoneNo: '',
      },
      rules: {
        email: [
          (value) => {
            if (!value) {
              return this.$_strings.messages.validation.REQUIRED('Email');
            }
            return this.isEmailValid(value) || this.$_strings.messages.validation.EMAIL;
          },
        ],
        phoneNo: [
          (v) => !!v || this.$_strings.messages.validation.REQUIRED('No. Telepon'),
          (value) => this.isPhoneNumberValid(value) || this.$_strings.messages.validation.PHONE_NUMBER,
        ],
        rolesId: [
          (v) => !!v || this.$_strings.messages.validation.REQUIRED(this.$_strings.userAdmin.ROLE_INPUT_LABEL),
        ],
        imageUrl: [
          (v) => !v || v.size < 500000 || this.$_strings.messages.validation.IMAGE_TOO_LARGE,
          (v) => !!this.form.imageUrl || this.$_strings.messages.validation.REQUIRED(this.$_strings.userAdmin.IMAGE_INPUT_LABEL),
        ],
      },
      roles: [],
      fileQueueDeletion: [],
      isSubmited: false,
    };
  },
  computed: {
    title() {
      return this.userId ? this.$_strings.userAdmin.EDIT_USERADMIN_PAGE_NAME : this.$_strings.userAdmin.CREATE_USERADMIN_PAGE_NAME;
    },
    userId() {
      return this.$route.params.userId;
    },
    companyId() {
      return this.$route.params.companyId;
    },
    isEditing() {
      return !!this.userId;
    },
  },
  methods: {
    fileUploadValidation(event, fileType) {
      if (!event) return;
      const { size } = event;
      // 500000 => 500kb
      const fileTypeSupport = ['jpg', 'jpeg', 'png'];
      if (!fileTypeSupport.includes(fileType)) {
        this.$dialog.notify.error('Format file tidak didukung');
        return false;
      }
      if (size > 500000) {
        this.$dialog.notify.error('Gambar Maksimum 500kb.');
        return false;
      }
      return true;
    },
    setFileInput(file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      const valid = this.fileUploadValidation(file, fileType);
      if (!valid) {
        return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const base64Image = e.target.result;
        this.formUpload.base64 = base64Image;
        this.formUpload.fileName = file.name;
        this.formUpload.fileType = fileType;
        this.form.imageUrl = base64Image;
      };
    },
    async deleteFile() {
      if (!this.formUpload.base64 && this.form.imageUrl) {
        try {
          this.formUpload.isLoading = true;
          const form = {
            url: this.form.imageUrl,
          };
          this.fileQueueDeletion.push(form);
          this.form.imageUrl = null;
        } finally {
          this.formUpload.isLoading = false;
        }
      } else {
        this.form.imageUrl = null;
        this.formUpload.fileName = null;
        this.formUpload.file = null;
        this.formUpload.fileType = null;
        this.formUpload.base64 = null;
      }
    },
    uploadImage() {
      const dataUser = this.$store.state.user.myUserInfo;
      const { companyId } = dataUser;
      const replaceEmail = this.form.email.replace('@', '_').replaceAll('.', '_');
      const { base64, fileType } = this.formUpload;
      const newFileName = replaceEmail.concat(`.${fileType}`);
      const filePath = `user/${companyId}/`;
      return this.$_services.uploads.uploadImage(base64, newFileName, filePath)
        .then((result) => {
          this.form.imageUrl = result.data.url;
          this.formUpload.file = null;
          if (this.fileQueueDeletion.length && this.fileQueueDeletion[0].url === result.data.url) {
            this.fileQueueDeletion = [];
          }
        }).finally(() => {
          this.$refs.form.validate();
          this.uploadingImage = false;
        });
    },
    fetchUserAdminDetail() {
      this.$root.$loading.show();
      this.$_services.userAdmins.fetchDetail(this.companyId, this.userId)
        .then((result) => {
          this.form = result.data;
        }).finally(() => {
          this.$root.$loading.hide();
        });
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        this.$nextTick(() => {
          const el = this.$el.querySelector('.v-messages.error--text:first-of-type');
          this.$vuetify.goTo(el, { offset: 50 });
        });
        return;
      }
      if (this.formUpload.base64) {
        try {
          this.$root.$loading.show();
          await this.uploadImage();
        } catch {
          this.$root.$loading.hide();
          return;
        }
      }
      this.$root.$loading.show();
      this.$_services.userAdmins.createEdit(this.form, this.userId)
        .then(() => {
          this.isSubmited = true;
          if (this.userId) {
            this.$dialog.notify.success(this.$_strings.userAdmin.SUCCESS_EDIT_USER_MESSAGE_TEXT);
          } else {
            this.$dialog.notify.success(this.$_strings.userAdmin.SUCCESS_CREATE_USER_MESSAGE_TEXT);
          }
          this.$router.go(-1);
        }).finally(() => {
          this.$root.$loading.hide();
        });
    },
    getRoleList() {
      this.$_services.userAdmins.roles()
        .then((res) => {
          this.roles = res.data.contents;
        }).finally(() => {
          this.$root.$loading.hide();
        });
    },
  },
  created() {
    const { data } = this.$route.params;
    if (data) {
      this.form = data;
    } else if (this.isEditing) {
      this.fetchUserAdminDetail();
    }
    this.getRoleList();
  },
};
</script>

<style>
</style>
